export const TID = {
    nav: {
        logo: "nav-logo",
        getStarted: "nav-get-started",
    },
    landing: {
        heroCta: "landing-hero-cta",
        heroSecondary: "landing-hero-secondary",
        section: "landing-section",
    },
    form: {
        name: "birth-form-name",
        date: "birth-form-date",
        time: "birth-form-time",
        cityInput: "birth-form-city-input",
        citySuggestion: (i) => `birth-form-city-suggestion-${i}`,
        ayanamsa: "birth-form-ayanamsa",
        submit: "birth-form-submit",
        error: "birth-form-error",
    },
    dashboard: {
        root: "dashboard-root",
        pdf: "dashboard-pdf-download",
        timeline: "dashboard-timeline",
        timelineBar: (i) => `timeline-md-bar-${i}`,
        domainCard: (k) => `domain-card-${k}`,
        bestTable: "best-windows-table",
        calendar: "action-calendar-24m",
        backHome: "dashboard-back-home",
    },
    disclaimer: "global-disclaimer",
    loader: "global-loader",
    auth: {
        loginEmail: "auth-login-email",
        loginPassword: "auth-login-password",
        loginSubmit: "auth-login-submit",
        loginGoogle: "auth-login-google",
        loginForgot: "auth-login-forgot",
        registerName: "auth-register-name",
        registerEmail: "auth-register-email",
        registerPassword: "auth-register-password",
        registerSubmit: "auth-register-submit",
        forgotEmail: "auth-forgot-email",
        forgotSubmit: "auth-forgot-submit",
        forgotSuccess: "auth-forgot-success",
        forgotDevLink: "auth-forgot-dev-link",
        resetPassword: "auth-reset-password",
        resetConfirm: "auth-reset-confirm",
        resetSubmit: "auth-reset-submit",
        changeCurrent: "auth-change-current",
        changeNew: "auth-change-new",
        changeSubmit: "auth-change-submit",
        changeSuccess: "auth-change-success",
        error: "auth-error",
        userMenu: "nav-user-menu",
        logout: "nav-logout",
        accountLink: "nav-account",
    },
    account: {
        root: "account-root",
        chartItem: (h) => `account-chart-${h}`,
        deleteChart: (h) => `account-chart-delete-${h}`,
        deleteAccount: "account-delete-self",
        profile: {
            card: "account-profile-card",
            edit: "account-profile-edit",
            cancel: "account-profile-cancel",
            save: "account-profile-save",
            fullName: "account-profile-fullname",
            dob: "account-profile-dob",
            tob: "account-profile-tob",
            place: "account-profile-place",
            gender: "account-profile-gender",
            occupation: "account-profile-occupation",
            marital: "account-profile-marital",
            currentLocation: "account-profile-currentloc",
            lifeGoals: "account-profile-goals",
            success: "account-profile-success",
            error: "account-profile-error",
        },
    },
    birthForm: {
        useProfile: "birth-form-use-profile",
    },
    shell: {
        sidebar: "app-sidebar",
        sidebarToggle: "app-sidebar-toggle",
        sidebarLink: (k) => `nav-${k}`,
        searchInput: "app-topbar-search",
        userCard: "app-sidebar-user",
    },
    chat: {
        panel: "dashboard-chat",
        input: "chat-input",
        send: "chat-send",
        suggestion: "chat-suggestion",
        msg: (role) => `chat-msg-${role}`,
    },
    dashboardX: {
        cosmicBlueprint: "dashboard-cosmic-blueprint",
        scoreTiles: "dashboard-score-tiles",
        scoreTile: (k) => `score-tile-${k}`,
        opportunityStrip: "dashboard-opportunity-strip",
        planetaryPeriod: "dashboard-planetary-period",
        agreementHero: "dashboard-agreement-hero",
        recommendedReports: "dashboard-recommended-reports",
        chartWheel: "dashboard-chart-wheel",
    },
    pricing: {
        root: "pricing-root",
        tierCard: (k) => `pricing-tier-${k}`,
        tierCta: (k) => `pricing-cta-${k}`,
        currentTierBanner: "pricing-current-tier-banner",
        upgradeBanner: "checkout-upgrade-banner",
        statusToast: "checkout-status-toast",
    },
    admin: {
        root: "admin-root",
        nav: (k) => `admin-nav-${k}`,
        overviewCard: (k) => `admin-overview-${k}`,
        usersTable: "admin-users-table",
        subsTable: "admin-subs-table",
        txTable: "admin-tx-table",
        grant: "admin-grant-submit",
    },
    deepdive: {
        root: (k) => `deepdive-root-${k}`,
        tabCareer: "deepdive-tab-career",
        tabWealth: "deepdive-tab-wealth",
        tabLife: "deepdive-tab-life",
    },
};
